(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const add = root.querySelector('[data-lab-add]');
    const input = root.querySelector('[data-lab-variant]');
    const error = root.querySelector('[data-lab-error]');
    const options = root.querySelector('[data-lab-options]');
    let controller;
    let requestNumber = 0;
    root.querySelectorAll('[data-lab-thumbnail]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-lab-thumbnail]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-lab-media]').forEach((panel) => {
          panel.hidden = panel.dataset.labMedia !== button.dataset.labThumbnail;
          if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
      });
    });
    const preserveApp = () => {
      const app = root.querySelector('#ymq-box');
      const fallback = root.querySelector('[data-lab-size-fallback]');
      if (!app) return;
      if (options.nextElementSibling !== app) options.after(app);
      if (fallback && /ring size|finger size/i.test(app.textContent) && app.querySelector('select')) {
        fallback.hidden = true;
        fallback.querySelector('input').required = false;
        fallback.querySelector('input').disabled = true;
      }
    };
    preserveApp();
    new MutationObserver(preserveApp).observe(form, {childList: true, subtree: true});
    form.addEventListener('submit', (event) => {
      if (!input.value || add.disabled) event.preventDefault();
    });
    options.addEventListener('change', async (event) => {
      if (!event.target.matches('[data-lab-option]')) return;
      if (controller) controller.abort();
      controller = new AbortController();
      const request = ++requestNumber;
      const url = new URL(root.dataset.productUrl, location.origin);
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', Array.from(options.querySelectorAll('select')).map((select) => select.selectedOptions[0].dataset.optionValueId).join(','));
      add.disabled = true;
      input.value = '';
      error.hidden = true;
      root.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Selection request failed');
        const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = documentCopy.querySelector('[data-beauties-lab]');
        if (!updated) throw new Error('Product content unavailable');
        if (request !== requestNumber) return;
        const nextOptions = updated.querySelector('[data-lab-options]');
        options.innerHTML = nextOptions.innerHTML;
        input.value = updated.dataset.variantId || '';
        root.dataset.variantId = input.value;
        root.dataset.available = updated.dataset.available;
        root.querySelector('[data-lab-price]').textContent = updated.querySelector('[data-lab-price]').textContent;
        add.disabled = updated.dataset.available !== 'true' || !input.value;
        add.textContent = add.disabled ? add.dataset.soldOutText : add.dataset.availableText;
        if (!input.value) {
          error.textContent = add.dataset.unavailableText;
          error.hidden = false;
        } else {
          const pageUrl = new URL(location.href);
          pageUrl.searchParams.delete('option_values');
          pageUrl.searchParams.set('variant', input.value);
          history.replaceState({}, '', pageUrl);
        }
        preserveApp();
      } catch (failure) {
        if (failure.name !== 'AbortError' && request === requestNumber) {
          error.textContent = error.dataset.loadError;
          error.hidden = false;
        }
      } finally {
        if (request === requestNumber) root.removeAttribute('aria-busy');
      }
    });
  };
  document.querySelectorAll('[data-beauties-lab]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-beauties-lab]').forEach(initialize));
})();
